import URI from 'urijs'

function normalize (param) {
  const url = new URI(param)
  return url.normalize()
}

export default {
  normalize
}
